module.exports = __webpack_public_path__ + "img/brazil.0dfd8bb0.svg";